// Action Types
import {
  FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE, FETCH_PROJECT_CATEGORIES,
  FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM, MAP_VIEWPORT_PROPERTIES,
  SELECT_FEATURE, FETCH_MAP_LAYERS_BY_LAYER, FETCH_MAP_LAYERS_BY_LAYER_SEARCH,
  SEARCH_TEXT, MAP_LAYER, FEATURE_DESCRIPTION
} from './actionTypes';

// Utils
import { logToConsole } from '../shared/utils/log';


const initialState = {
  mapLayersByProjCatTree: null,
  projectCategoryFromCSS: null,
  isFetchingDataLayer: false,
  currentLayer: null,
  currentFeature: null,
  mapViewportProperties: null,
  projectCategories: [],
  search: null,
  selectedMapLayer: null,
  searchSuggestions: null,
  isFeatureDescriptionShown: false
};

// eslint-disable-next-line
export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE.request(): {
      return {
        ...state,
        mapLayersByProjCatTree: null,
        projectCategoryFromCSS: null,
        currentLayer: null,
        currentFeature: null,
        search: null,
        selectedMapLayer: null
      };
    }

    case FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE.success(): {
      const { mapLayersByProjCatTree, projectCategoryFromCSS } = action.payload;

      return {
        ...state,
        mapLayersByProjCatTree,
        projectCategoryFromCSS
      };
    }

    case FETCH_MAP_LAYERS_BY_PROJ_CAT_TREE.error(): {
      logToConsole('Fetch Map Layers By Proj Cat Tree Error: ', action.payload);
      return state;
    }

    case FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM.request(): {
      return {
        ...state,
        isFetchingDataLayer: true,
        currentLayer: null,
        currentFeature: null,
        isFeatureDescriptionShown: false
      };
    }

    case FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM.success(): {
      return {
        ...state,
        isFetchingDataLayer: false,
        currentLayer: action.payload
      };
    }

    case FETCH_KML_BY_SOURCE_BOUNDINGBOX_ZOOM.error(): {
      logToConsole('Fetch KMl By Source, Bounding Box and Zoom: ', action.payload);
      return {
        ...state,
        isFetchingDataLayer: false
      };
    }

    case SELECT_FEATURE.success(): {
      return {
        ...state, currentFeature: action.payload,
        isFeatureDescriptionShown: false
      };
    }

    case MAP_VIEWPORT_PROPERTIES.update(): {
      return { ...state, mapViewportProperties: action.payload };
    }

    case FETCH_PROJECT_CATEGORIES.request(): {
      return { ...state, projectCategories: [] };
    }

    case FETCH_PROJECT_CATEGORIES.success(): {
      return { ...state, projectCategories: action.payload };
    }

    case FETCH_PROJECT_CATEGORIES.error(): {
      logToConsole('Fetch Project Categories Error: ', action.payload);
      return state;
    }

    case FETCH_MAP_LAYERS_BY_LAYER.request(): {
      return { ...state, search: null };
    }

    case FETCH_MAP_LAYERS_BY_LAYER.success(): {
      return { ...state, search: action.payload };
    }

    case FETCH_MAP_LAYERS_BY_LAYER.error(): {
      logToConsole('Fetch Map Layers Error: ', action.payload);
      return state;
    }

    case FETCH_MAP_LAYERS_BY_LAYER_SEARCH.request(): {
      return { ...state, searchSuggestions: null };
    }

    case FETCH_MAP_LAYERS_BY_LAYER_SEARCH.success(): {
      return { ...state, searchSuggestions: action.payload };
    }

    case FETCH_MAP_LAYERS_BY_LAYER_SEARCH.error(): {
      logToConsole('Fetch Map Layers Search (Suggestions) Error: ', action.payload);
      return state;
    }

    case SEARCH_TEXT.clear(): {
      return { ...state, search: null };
    }

    case MAP_LAYER.select(): {
      return { ...state, search: null, selectedMapLayer: action.payload };
    }

    case FEATURE_DESCRIPTION.toggle(): {
      return { ...state, isFeatureDescriptionShown: !state.isFeatureDescriptionShown };
    }

    default:
      return state;
  }
}
